import Item from '../Item';

export default class MountingRail extends Item {
  constructor(args) {
    super(args);
    this.disableInteraction = true;
    this.cursor = 'default';
  }

  draw() {
    super.draw();

    this.alpha =
      this.options?.wallResizerActive || this.app?.dragging?.item ? 0 : 1;
  }
}
